import { Link, useNavigate, useParams } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";

/**
 * View as creator: renders the exact Dashboard the creator sees, using the
 * existing admin impersonation endpoint `/api/admin/dashboard/{id}` which
 * sets is_admin_view=true on the payload. The creator id is passed to
 * Dashboard as a prop; writing ?view_as= with history.replaceState is
 * invisible to React Router, so the admin saw their own dashboard. The
 * is_admin_view banner disables creator-only actions.
 */
export default function AdminCreatorView() {
    const { id } = useParams();
    const navigate = useNavigate();
    return (
        <div
            data-testid="admin-view-as"
            className="min-h-screen bg-paper -mx-4 sm:-mx-6 lg:-mx-8 -mt-6 pb-10"
        >
            <div
                data-testid="admin-view-as-bar"
                className="sticky top-0 z-30 bg-ink text-paper px-4 py-2 flex items-center justify-between gap-3"
            >
                <div className="text-xs font-mono uppercase tracking-wider truncate">
                    Viewing as creator · read only
                </div>
                <button
                    type="button"
                    data-testid="admin-view-as-exit"
                    onClick={() => navigate(`/admin/creators/${id}`)}
                    className="text-xs font-mono uppercase tracking-wider underline underline-offset-4"
                >
                    Exit
                </button>
            </div>
            <Dashboard viewAs={id} />
            <Link
                to={`/admin/creators/${id}`}
                className="fixed bottom-6 right-6 samoony-chip bg-ink text-paper"
                data-testid="admin-view-as-back"
            >
                Back to admin
            </Link>
        </div>
    );
}
